import { ComponentsImports } from '@/shared/app/model/ComponentsImports';

export const UniComponents: ComponentsImports = {
  Dish: () => import('@shared/uni/templating/components/dish/ui/Dish.vue'),
  UniLine: () => import('@shared/uni/templating/components/line/ui/Line.vue'),
  OriginsScroller: () => import('@shared/uni/templating/components/dish/ui/OriginsScroller.vue'),

  DishesGroup: () => import('@shared/uni/templating/components/dishesGroup/ui/DishesGroup.vue'),

  TText: () => import('@shared/uni/templating/components/text/ui/TText.vue'),
  TextArea: () => import('@shared/uni/templating/components/text/ui/TextArea.vue'),

  Communications: () =>
    import('@shared/uni/templating/components/communications/ui/Communications.vue'),

  Time: () => import('@shared/uni/templating/components/time/ui/Time.vue'),
  WaitingTime: () => import('@shared/uni/templating/components/waitingTime/ui/WaitingTime.vue'),
};
